import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "../SectionHeading";
import { StaggerGroup, StaggerItem } from "../Reveal";
import { INDUSTRIES } from "../../data/site";

export const Industries = () => {
  return (
    <section data-testid="industries-section" className="relative py-24 md:py-32 bg-navy-deep">
      <div className="container-x">
        <SectionHeading
          overline="Industries"
          title="Domains we serve"
          subtitle="Cross-industry delivery experience — we speak the language of your business, not just the tech."
        />

        <StaggerGroup className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4" stagger={0.07}>
          {INDUSTRIES.map((ind) => {
            const Icon = ind.icon;
            return (
              <StaggerItem key={ind.name}>
                <motion.div
                  whileHover={{ y: -6 }}
                  transition={{ type: "spring", stiffness: 300, damping: 20 }}
                  data-testid={`industry-${ind.name.split(" ")[0].toLowerCase()}`}
                  className="group glass rounded-2xl p-6 md:p-8 flex flex-col items-center text-center gap-4 h-full hover:border-brand-orange/40 transition-colors duration-300"
                >
                  <span className="w-14 h-14 rounded-2xl bg-white/5 grid place-items-center group-hover:bg-brand-orange transition-colors duration-300">
                    <Icon size={26} className="text-brand-orange group-hover:text-white transition-colors duration-300" />
                  </span>
                  <span className="font-head font-medium text-white">{ind.name}</span>
                </motion.div>
              </StaggerItem>
            );
          })}
        </StaggerGroup>
      </div>
    </section>
  );
};

export default Industries;
